(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('QueueTypeDialogController', QueueTypeDialogController);

    QueueTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'QueueType'];

    function QueueTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, QueueType) {
        var vm = this;

        vm.queueType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.queueType.id !== null) {
                QueueType.update(vm.queueType, onSaveSuccess, onSaveError);
            } else {
                QueueType.save(vm.queueType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:queueTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
